import { IconTypes } from './Icons'

export default function ArrowTail({
  color = '',
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: Readonly<IconTypes>) {
  return (
    <svg
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
    >
      <path
        d='M17 9C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7L17 9ZM0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538407 6.65686 0.928931L0.292893 7.29289ZM17 7L1 7L1 9L17 9L17 7Z'
        fill={color ? color : 'currentColor'}
      />
    </svg>
  )
}
